import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Calcul de la note au test - Calculatrice de note d'examen";
const DESCRIPTION =
  "Calcul de la note au test - Calculatrice de note d pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "calcul de la note au test de note d, calculatrice calcul de la note au test de note d, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/test-grade";
function GradeCalculator() {
  const [points, setPoints] = useState("");
  const [wrong, setWrong] = useState("");
  const [correct, setCorrect] = useState("");
  const [percentage, setPercentage] = useState("");
  const [grade, setGrade] = useState("");
  useEffect(() => {
    const pointsValue = parseFloat(points) || 0;
    const wrongValue = parseFloat(wrong) || 0;
    const correctValue = parseFloat(correct) || 0;
    if (pointsValue > 0) {
      if (wrong !== "" && correct === "") {
        const calculatedCorrect = pointsValue - wrongValue;
        setCorrect(calculatedCorrect >= 0 ? calculatedCorrect.toString() : "");
      } else if (correct !== "" && wrong === "") {
        const calculatedWrong = pointsValue - correctValue;
        setWrong(calculatedWrong >= 0 ? calculatedWrong.toString() : "");
      }
      const finalCorrect =
        wrong !== "" ? pointsValue - wrongValue : correctValue;
      if (finalCorrect >= 0 && finalCorrect <= pointsValue) {
        const percentageValue = (finalCorrect / pointsValue) * 100;
        setPercentage(Math.round(percentageValue * 100) / 100);
        let gradeValue = "";
        if (percentageValue >= 90) {
          gradeValue = "A";
        } else if (percentageValue >= 80) {
          gradeValue = "B";
        } else if (percentageValue >= 70) {
          gradeValue = "C";
        } else if (percentageValue >= 60) {
          gradeValue = "D";
        } else {
          gradeValue = "F";
        }
        setGrade(gradeValue);
      } else {
        setCorrect("");
        setPercentage("");
        setGrade("");
      }
    }
  }, [points, wrong, correct]);
  const handlePointsChange = (e) => setPoints(e.target.value);
  const handleWrongChange = (e) => {
    setWrong(e.target.value);
    if (points !== "") {
      setCorrect((parseFloat(points) - parseFloat(e.target.value)).toString());
    }
  };
  const handleCorrectChange = (e) => {
    setCorrect(e.target.value);
    if (points !== "") {
      setWrong((parseFloat(points) - parseFloat(e.target.value)).toString());
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <p>
            Cette calculatrice de note d'examen est un outil indispensable si vous recherchez un outil pour vous aider à déterminer l'échelle de notes. Également connue sous le nom de calculatrice de notes d'examen ou d'outil d'estimation de l'enseignant, cette calculatrice vous permet de trouver rapidement la note et le pourcentage en fonction du nombre de points et des réponses incorrectes (ou correctes). De plus, vous pouvez modifier l'échelle de notes par défaut et définir votre propre échelle. Vous vous posez encore des questions sur la façon de calculer les notes d'examen? Continuez à lire pour en savoir plus - ou essayez simplement cette calculatrice de notation des examens.
          </p>
           <MobileUnderCalAds />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <div className="p-3 mb-2 bg-success text-white">
                <h2 style={{ fontSize: "16px" }}>Calcul de note d'examen</h2>
              </div>
              <hr />
              <div className="form-group">
                <b>
                  <label htmlFor="points">Points possibles:</label>
                </b>
                <input
                  type="number"
                  value={points}
                  id="points"
                  onChange={handlePointsChange}
                  className="form-control"
                  placeholder="100"
                />
              </div>
              <div className="form-group">
                <b>
                  <label htmlFor="wrong">Réponses erronées:</label>
                </b>
                <input
                  type="number"
                  value={wrong}
                  id="wrong"
                  onChange={handleWrongChange}
                  className="form-control"
                  placeholder="0"
                />
              </div>
              <div className="form-group">
                <b>
                  <label htmlFor="correct">Réponses correctes:</label>
                </b>
                <input
                  type="number"
                  value={correct}
                  id="correct"
                  onChange={handleCorrectChange}
                  className="form-control"
                  placeholder="100"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-7">
              <br />
              {percentage !== "" &&  (
                <div className="bg-light bg-gradient text-dark">
                  <div className="p-3 mb-2 bg-success bg-gradient text-white">
                    <strong>Résultats</strong>
                  </div>
                  <b>Pourcentage: </b>
                  {percentage}%
                  <br />
                  <b>Note: </b>
                  {grade}
                  <br />
                </div>
              )}
            </div>
          </div>
          <hr />
          <div className="row">
            <RelatedLinks />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default GradeCalculator;
